import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import VideoPlayer from '../../../common/VideoPlayer/VideoPlayerComponent';
import Button from '../../../common/button/Button';
import Slider from '../../../common/Slider/Slider';

class MusicSingleVideosSlider extends Component {
    _mapVideos() {
        const videosArr = [];
        let videoQuality = null;

        if (this.props.isExtraLarge || this.props.isLarge || this.props.isMedium) {
            videoQuality = '720p';
        } else {
            videoQuality = '480p';
        }

        if (this.props.musicVideoYoutubeId) {
            videosArr.push(
                <div className="slideWrapper" key="Official Video">
                    <div className="youtubeContainer">
                        <iframe
                            title="Vídeo destaque"
                            src={`https://www.youtube.com/embed/${this.props.musicVideoYoutubeId}?autoplay=false`}
                            allowFullScreen
                        />
                    </div>
                </div>,
            );
        } else if (this.props.musicVideoFileName) {
            videosArr.push(
                <div className="slideWrapper" key="Official Video">
                    <VideoPlayer
                        where="musicSinglePage"
                        videoQuality={videoQuality}
                        fileName={this.props.musicVideoFileName}
                    />
                </div>,
            );
        }

        if (this.props.lyricsVideoYoutubeId) {
            videosArr.push(
                <div className="slideWrapper" key="Lyrics Video">
                    <div className="youtubeContainer">
                        <iframe
                            title="Vídeo destaque"
                            src={`https://www.youtube.com/embed/${this.props.lyricsVideoYoutubeId}?autoplay=false`}
                            allowFullScreen
                        />
                    </div>
                </div>,
            );
        } else if (this.props.lyricsVideoFileName) {
            videosArr.push(
                <div className="slideWrapper" key="Lyrics Video">
                    <VideoPlayer
                        where="musicSinglePage"
                        videoQuality={videoQuality}
                        fileName={this.props.lyricsVideoFileName}
                    />
                </div>,
            );
        }

        return videosArr;
    }

    render() {
        // DEFINE ARROW FUNCTION CLASS

        return (
            <div className="sliderMusicSingle">
                {
                    (this.props.musicVideoYoutubeId
                        || this.props.musicVideoFileName
                        || this.props.lyricsVideoYoutubeId
                        || this.props.lyricsVideoFileName)
                        ? (
                            <Slider
                                autoplay={false}
                                navigation
                                loop={false}
                            >
                                {this._mapVideos()}
                            </Slider>
                        ) : (
                            <p className="noContentWarning">
                                Não há vídeos disponíveis para essa faixa... : (
                                <br />
                                Entre em
                                {' '}
                                <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                                {' '}
                                para ajudar a completar a página!
                            </p>
                        )
                }
            </div>
        );
    }
}

MusicSingleVideosSlider.propTypes = exact({
    musicVideoYoutubeId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    musicVideoFileName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    lyricsVideoYoutubeId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    lyricsVideoFileName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    isExtraLarge: PropTypes.bool,
    isLarge: PropTypes.bool,
    isMedium: PropTypes.bool,
});

export default MusicSingleVideosSlider;
